module.exports = new __parcel__URL__("MSExcel.09868f4b.svg").toString();